import { Box } from '@mui/material';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export const UnAvailableButtonStyled = withTheme(styled(Box)`
  background: rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  color: white;
  padding: ${(props: any) => props.padding || '14px'};
  height: ${(props: any) => (props.height || props.isFooter ? '72px' : '100%')};
  width: ${(props: any) => props.width || '100%'};
  display: flex;

  @media only screen and (max-width: 1199px) and (min-width: 768px) {
    width: ${(props: any) => props.width || '100%'};
    height: ${(props: any) => props.height || 'fit-content'};
    justify-content: center;
    display: flex;
  }

  @media only screen and (max-width: 767px) {
    height: 60px;
    width: ${(props: any) => props.width || '100%'};
    justify-content: center;
    align-items: center;
    align-self: center;
    align-content: center;
    padding: ${(props: any) => props.padding || '4px'};
  }

  .container-box {
    display: flex;
    flex-direction: row;
    align-items: inherit;
    justify-content: start;

    @media only screen and (max-width: 1199px) and (min-width: 768px) {
      display: flex;
      align-items: baseline;
      justify-content: center;
      text-align: ${(props: any) => (!props.isFooter ? 'center' : 'unset')};
      align-self: center;
      align-content: center;
    }

    @media only screen and (max-width: 767px) {
      display: flex;
      align-items: baseline;
      justify-content: center;
      text-align: ${(props: any) => (!props.isFooter ? 'center' : 'unset')};
      align-self: center;
      align-content: center;
    }
  }

  .cannot-train-icon {
    width: 22px;
    height: 22px;
    font-size: 22px;
    position: relative;
    top: -2;

    @media only screen and (max-width: 1199px) and (min-width: 768px) {
      width: 22px;
      height: 22px;
      font-size: 22px;
      position: relative;
      top: 4px;
    }

    @media only screen and (max-width: 767px) {
      width: 14px;
      height: 14px;
      font-size: 22px;
      top: 2px;
      position: relative;
    }
  }

  .title-text {
    line-height: 1;
    white-space: pre-line;
    word-wrap: break-word;

    @media only screen and (max-width: 1199px) and (min-width: 768px) {
      width: ${(props: any) => (!props.isFooter ? '330px' : '198px')};
      font-size: ${(props: any) => (props.isFooter ? '18px' : '24px')};
      white-space: pre-line;
      word-wrap: break-word;
    }

    @media only screen and (max-width: 767px) {
      width: ${(props: any) => (!props.isFooter ? '154px' : '113px')};
      font-size: 14px;
      white-space: pre-line;
      word-wrap: break-word;
    }
  }

  .link-button {
    height: fit-content;
  }
`);
